"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _Chevron = _interopRequireDefault(require("../Chevron"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 3px solid rgba(225, 0, 120, 0.5);\n\tborder-radius: 50%;\n\twidth: 2rem;\n\theight: 2rem;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\n\tsvg {\n\t\tfill: ", ";\n\t\tmargin: 0 auto;\n\t}\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: ", ";\n\n\t\tsvg {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Circle = _styledComponents.default.div(_templateObject(), _colors.default.secondary, _colors.default.secondary, _colors.default.secondary, _colors.default.white);

Circle.displayName = 'Circle';

var CircledChevron = function CircledChevron(_ref) {
  var expanded = _ref.expanded,
      props = _objectWithoutPropertiesLoose(_ref, ["expanded"]);

  return _react.default.createElement(Circle, props, _react.default.createElement(_Chevron.default, {
    expanded: expanded
  }));
};

CircledChevron.displayName = 'CircledChevron';
CircledChevron.propTypes = {
  expanded: _propTypes.default.bool.isRequired
};
var _default = CircledChevron;
exports.default = _default;